//const API_URL = "https://appsqa.isbe.net/SEPF_WebApi"
const API_URL = "https://apps.isbe.net/SEPF_WebApi"

//const API_URL = "http://localhost:7769"

//const API_URL = "http://localhost:7769"


export default {
  API_URL: API_URL
}